// class Queue {
//   constructor () {
//     this.items = []
//   }
//
//   enqueue (elem) {
//     this.items.push(elem)
//   }
//   dequeue () {
//     return this.items.shift()
//   }
//   // front () {
//   //   return this.items[0]
//   // }
//   isEmpty () {
//     return this.items.length === 0
//   }
//   // clear () {
//   //   this.items = []
//   // }
//   // size () {
//   //   return this.items.length
//   // }
// }

export function BFS (rootNode, callback) {
  // const queue = new Queue()

  if (!rootNode) {
    return
  }

  // queue.enqueue(rootNode)
  const unvisitedQueue = [rootNode]

  let currentNode
  while (unvisitedQueue.length !== 0) {
    currentNode = unvisitedQueue.shift()

    if (callback(currentNode) === false) {
      break
    }

    if (currentNode.children && currentNode.children.length) {
      unvisitedQueue.push(...currentNode.children)
    }
  }
}

export function DFS (rootNode, callback) {
  if (!rootNode) {
    return
  }

  const unvisitedList = [rootNode]

  while (unvisitedList.length !== 0) {
    const current = unvisitedList.shift()

    if (callback(current) === false) {
      break
    }

    if (!current.children || !current.children.length) {
      continue
    }

    unvisitedList.unshift(...current.children) // list 앞에다 넣어준다. (우선순위: 내 자식들이 먼저야! )
  }
}
